<template>
  <div class="upcoming-jobs-list">
    <!-- <div> -->
    <div class="card" v-if="upcomingJobs.length">
      <div
        class="transactions card-content"
        v-for="t in upcomingJobs"
        :key="t.id"
        @click="goToJob(t)"
      >
        <div class="content has-text-left">
          <div>
            <span>
              <i
                v-if="isActive(t)"
                class="fa fa-spinner fa-spin has-text-success pad"
              />
              <i v-else class="fa fa-clock pad" />
              {{ longScheduledTime(t) }}
              <span class="tag has-text-weight-semibold">{{
                humanTime(t)
              }}</span>
              <span class="is-pulled-right has-text-weight-semibold">
                <span v-if="isActive(t)" class="tag is-success">{{
                  prettyState(t)
                }}</span>
                <span v-else class="tag is-link">{{ prettyState(t) }}</span>
              </span>
            </span>
          </div>
          <div class="content is-pulled-right" style="margin-top: 20px">
            <span class="button icon is-white" @click="goToJob(t)">
              <i class="fa fa-chevron-right fa-2x" />
            </span>
          </div>
          <div v-if="t.data.pickup_stop">
            <i class="fa fa-map-marker-alt has-text-link pad" />
            {{ $t("driver.pickup-at") }}
            <a>{{ t.data.pickup_stop.name }}</a>
          </div>
          <div v-if="t.data.dropoff_stop">
            <i class="fa fa-map-marker-alt has-text-success pad" />
            {{ $t("driver.dropoff-at") }}
            <a>{{ t.data.dropoff_stop.name }}</a>
          </div>
          <div>
            <i class="fa fa-coins pad" />
            <span v-if="t.data.fare">
              <!-- <span>{{ prettyFare(t) }}</span> -->
              <span>
                ฿{{ t.data.fare.cash }} Cash | ฿{{ t.data.fare.tukpay }} TukPay
                <span class="tag has-text-weight-semibold"
                  >฿{{ t.data.fare.price }} Total</span
                >
              </span>
            </span>
          </div>
          <div style="height: 15px" />
          <div v-if="requiresConfirmation(t)">
            <span
              class="button confirm-btn is-fullwidth is-success is-rounded has-text-weight-semibold"
              @click="confirmJob(t)"
              >Click Now to Confirm</span
            >
            <div style="height: 12px" />
          </div>
          <hr />
        </div>
      </div>
    </div>

    <div v-else class="card">
      <div class="card-content" style="padding-bottom: 18px">
        {{ $t("profile.no-upcoming-jobs") }}
      </div>
    </div>

    <br />

    <button class="button is-rounded is-warning" @click="updateTrips(true)">
      {{ $t("update") }}
    </button>

    <UpcomingJobModal />
    <!-- <EditTransactionModal /> -->
  </div>
</template>

<script>
import EventBus from "../eventBus";
import UpcomingJobModal from "@/components/UpcomingJobModal.vue";
// import EditTransactionModal from "@/components/EditTransactionModal.vue";

export default {
  components: {
    UpcomingJobModal,
    // EditTransactionModal
  },
  data() {
    return {};
  },
  computed: {
    upcomingJobs() {
      return this.$store.getters.getWorkerTransactionsStateScheduled;
      // return this.$store.getters.getOngoingWorkerTransactions.filter((t) => {
      //   t.workflow_type_name !== "Commerce";
      // });
    },
  },
  mounted() {},
  methods: {
    setTab(e) {
      this.tab = e.target.id;
    },
    requiresConfirmation(t) {
      if (t.state !== "scheduled") return false;
      if (!t.data.scheduled_time) return false;
      var diff = new Date(t.data.scheduled_time) - new Date();
      var minutes = diff / (1000 * 60);
      console.log("diff minutes", minutes);
      if (minutes > 60) return false;
      return true;
    },
    isActive(t) {
      if (t.state === "scheduled") return false;
      return true;
    },
    isPrepaid(t) {
      if (!t.data.fare) return false;
      if (t.data.fare.cash > 0) return false;
      return true; // means cash === 0
    },
    isScheduled(t) {
      if (t.state === "scheduled") return true;
      return false;
    },
    isOngoing(t) {
      if (t.state !== "scheduled" && t.is_ongoing) return true;
      return false;
    },
    goToJob(t) {
      if (t.state === "scheduled") {
        EventBus.$emit("UPCOMING_JOB", t); // VIEW_TRANSACTION
        this.$nextTick(() => this.displayModal(".upcoming-job-modal"));
        return;
      }
      this.$router.push("/tuktuk"); // else go to transport page
    },
    prettyState(t) {
      return t.state;
    },
    prettyFare(t) {
      return `฿${t.data.fare.cash} Cash, ฿${t.data.fare.tukpay} TukPay ฿${t.data.fare.price} Total)`;
    },
    addUpcomingTrip() {
      this.$router.push("/tuktuk");
    },
    reOrder(r) {
      this.console("reorder for role", r);
      this.$router.push(`/tuktuk?workflow_id=${r.workflow_id}`).catch((err) => {
        console.error("reOrder router.push error", err);
      });
    },
    confirmJob(t) {
      var loader = this.loadingDots();
      this.$store
        .dispatch("patchTransaction", {
          transactionID: t.id,
          data: { state: "confirmed" },
        })
        .then(() => this.updateTrips(true))
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
  },
};
</script>

<style scoped>
p {
  margin-bottom: 5px;
}
hr {
  margin: 0px -20px 0px; /* margin: 0 0; */
}
.pad {
  text-align: center;
  width: 30px;
}
.tag {
  padding: 6px;
}
.card-content {
  padding: 18px;
  padding-left: 10px;
  padding-bottom: 0px;
  /* border-radius: 25px; */
}
.confirm-btn {
  animation: shadow-pulse 1s 999;
}
/* box-shadow: 0 0 0 0px rgba(247, 211, 8, 0.95); */
@keyframes shadow-pulse {
  0% {
    box-shadow: 0 0 0 0px rgba(247, 8, 247, 0.95);
  }
  100% {
    box-shadow: 0 0 0 13px rgba(247, 8, 247, 0);
  }
}
</style>